import { AddTicketsToCartResult, AddToCartResult } from ".";

export type AddPackageTicketsToCartResult = AddToCartResult & {
    EventDateResultsIsSuccess?: boolean;
    EventDatesResults?: AddTicketsToCartResult[];
};